import { colors } from '../../colors'

interface PriceFormatterProps {
  price: number
  showCurrency?: boolean
  style?: React.CSSProperties
}

const PriceFormatter: React.FC<PriceFormatterProps> = ({
  price,
  showCurrency = true,
  style = {},
}) => {
  const formatPrice = (price: number, showCurrency: boolean) => {
    const formattedPrice = price.toLocaleString('ja-JP')
    return showCurrency ? `${formattedPrice}円` : formattedPrice
  }

  const defaultStyles: React.CSSProperties = {
    fontWeight: 'normal',
    color: colors['text-secondary'],
    ...style,
  }

  return <span style={defaultStyles}>{formatPrice(price, showCurrency)}(税込)</span>
}

export default PriceFormatter
